<template>
  <div class="content container login-container" :class="{ 'full-width-layout': fullWidthLayout }">
     <Login ref="login" :screen-data="pageData.login" :profile-caller-id="profileCallerId"></Login>
     <PardonUs ref="pardonUs" :screen-data="pageData.pardonUs"></PardonUs>
     <MultiFactorEnroll ref="mfaEnroll" :screen-data="pageData.mfaEnroll"></MultiFactorEnroll>
     <MultiFactorSelect ref="mfaSelect" :screen-data="pageData.mfaSelect"></MultiFactorSelect>
     <MultiFactorVerify ref="mfaVerify" :screen-data="pageData.mfaVerify" :uses-threat-metrics-only="usesThreatMetricsOnly"></MultiFactorVerify>
     <AccountHold ref="accountHold" :screen-data="pageData.accountHold"></AccountHold>
     <ChallengePII ref="challengePII" :screen-data="pageData.challengePII" :profile-caller-id="profileCallerId"></ChallengePII>
     <NewUser ref="newUser" :screen-data="pageData.newUser" :profile-caller-id="profileCallerId"></NewUser>
     <ResetPassword ref="resetPassword" :screen-data="pageData.resetPassword"></ResetPassword>
     <RetrieveUsername ref="retrieveUser" :screen-data="pageData.retrieveUser"></RetrieveUsername>
     <Disclaimer ref="disclaimer" :screen-data="pageData.disclaimer"></Disclaimer>
     <BroadcastMessages ref="broadcast" :screen-data="pageData.broadcast"></BroadcastMessages>
     <SaveForLater ref="saveForLater" :screen-data="pageData.saveForLater"></SaveForLater>
     <SkipMFA ref="skipMfa" :screen-data="pageData.skipMfa"></SkipMFA>
     <ConsentInformation ref="consentInfo" :screen-data="pageData.consentInfo"></ConsentInformation>
  </div>
</template>

<script>
  import Login from '../pages/Login.vue';
  import PardonUs from '../pages/PardonUs.vue';
  import MultiFactorEnroll from '../pages/MultiFactorEnroll.vue';
  import MultiFactorSelect from '../pages/MultiFactorSelect.vue';
  import MultiFactorVerify from '../pages/MultiFactorVerify.vue';
  import AccountHold from '../pages/AccountHold.vue';
  import ChallengePII from '../pages/ChallengePII.vue';
  import NewUser from '../pages/NewUser.vue';
  import ResetPassword from '../pages/ResetPassword.vue';
  import RetrieveUsername from '../pages/RetrieveUsername.vue';
  import Disclaimer from '../pages/Disclaimer.vue';
  import BroadcastMessages from '../pages/BroadcastMessages.vue';
  import SaveForLater from '../pages/SaveForLater.vue';
  import SkipMFA from '../pages/SkipMFA.vue';
  import ConsentInformation from '../pages/ConsentInformation.vue';
  //import {sendAnalyticsData} from "../../../utility/miscellaneous";

  export default {
    name: "Content",
    activeComponent: null,

    components: {
      Login,
      PardonUs,
      MultiFactorEnroll,
      MultiFactorSelect,
      MultiFactorVerify,
      AccountHold,
      ChallengePII,
      NewUser,
      ResetPassword,
      RetrieveUsername,
      Disclaimer,
      BroadcastMessages,
      SaveForLater,
      SkipMFA,
      ConsentInformation
    },

    data: function() {
      return {
        fullWidthLayout: false
      }
    },

    props: {
      pageData: Object,
      profileCallerId: String,
      usesThreatMetricsOnly: Boolean
    },

    methods: {
      init: function() {
        var componentName = this.pageData.initial;

        if (this.showPardonUs) {
          componentName = "pardonUs";
        }

        this.$refs[componentName].show({
          _IS_INITIAL: true
        });
        this.activeComponent = componentName;
        //sendAnalyticsData();
      },

      navigate: function(route) {
        var componentName, routeData;

        if(typeof route == "string") {
          componentName = route;
        } else if (route && typeof route == "object") {
          componentName = route.componentName;
          routeData = route.routeData;
        }

        this.$refs[this.activeComponent].hide();
        this.activeComponent = componentName;
        this.$refs[this.activeComponent].show(routeData);
        //sendAnalyticsData();
      }
    },

    computed: {
      showLogonHash: function() {
        return window.location.hash === "#showLogon";
      },

      showPardonUs: function() {
        return this.pageData.showPardonUs && !this.showLogonHash;
      }
    },

    mounted: function() {
      this.init();
      this.$emitter.on('navigate', this.navigate);
    },

    created: function() {
      this.$emitter.on("set-full-width-layout", () => {
        this.fullWidthLayout = true;
      });

      this.$emitter.on("set-default-layout", () => {
        this.fullWidthLayout = false;
      });
    },

    unmounted: function() {
      this.$emitter.off('navigate', this.navigate);
      this.$emitter.off("set-full-width-layout");
      this.$emitter.off("set-default-layout");
    },
  }
</script>

<style scoped>
  .login-container {
    max-width: 800px;
    margin: 0 auto;
  }
  .full-width-layout {
    max-width: 1440px;
    padding: 0 100px;
  }
</style>